angular
  .module('monitoringCarousel.components', [])
  .component('monitoringCarousel', {
    templateUrl: 'ng/components/monitoringCarousel/monitoringCarousel.view.html',
    controllerAs: 'monitoringCarouselCtrl',
    bindings: {
      configObj: '='
    },
    controller: function ($scope, $sessionStorage, $rootScope, $location, $searchUserService, $monitoringService, $portalService, $userService, $featureService, $configService) {
      console.log("monitoringCarousel.components - $rootScope.portalName=" + $rootScope.portalName);
      if ($rootScope.portalName == 'ILEAF_ARF') {
        $scope.isARF = true;
      } else {
        $scope.isARF = false;
      }

      $scope.ArfSelectUserMonitoring = $featureService.ArfSelectUserMonitoring();
      //$scope.ArfSelectUserMonitoring = false;



      /** this refererence depends from context */
      var self = this;
      self.selectedVendor = {
        identifier: null
      };
      self.monitoringService = $monitoringService;
      self.showVendorSelect = false;
      //** If in arf, do not show the vendor select */
      if ('ILEAF_ARA' == $portalService.resolveContextApplicationName($rootScope.context)) {
        self.showVendorSelect = true;
      } else {
        self.selectedVendor = {
          identifier: $configService.getUser().identifier
        };
      }





      $scope.changeUser = function () {
        console.log("CHANGE USER- ID=" + $scope.actualUser);
        self.selectedVendor = {
          identifier: $scope.actualUser
        };
        self.fetchAndRedrawCharts();

      }

      $scope.getAllChild = function () {
        $userService.getFullChildren().then(function (userList) {
          for (i = 0; i < userList.length; i++) {
            $scope.users.push(new user(userList[i].name + " " + userList[i].surname, userList[i].identifier));
          }
        });
      }

      function user(name, id) {
        var self = this;
        self.totalName = name;
        self.identifier = id;
      }
      $scope.users = [];
      $scope.actualUser = $configService.getUser().identifier;
      $scope.parentUser = {
        name: $configService.getUser().name,
        identifier: $configService.getUser().identifier
      }
      $scope.getAllChild();





      var pieChart = null;
      var barChart = null;
      var doughnutChart = null;

      self.vendorList = [];

      //hook on the carousel slide
      $('.carousel').on('slide.bs.carousel', function () {
        //console.log('slide slided!');
      })

      self.activeChart = 0;
      self.chartTitles = ['Proposte e contratti', 'dettaglio proposte sottomesse', 'plafond'];

      var keys = [
        //left sidebar
        'app.kpi.getAllContractStatusWaitingSignature',
        'app.kpi.getAllContractStatusEvaluating',
        'app.kpi.getAllSimulationNotCompleted',
        //right sidebar
        'app.kpi.getCountTotalContractCurrentYear',
        'app.kpi.getCountTotalSimulationCurrentYear',
        'app.kpi.getCountTotalCustomerCurrentYear',
        //grafici
        'app.kpi.simulationsAndContractsChart',
        'app.kpi.proposalsChart',
        'app.kpi.plafondChart'
      ];


      self.initialize = function () {
        //if we are in ara
        if (self.showVendorSelect) {
          //fetch vendors, fetch charts data and draw them
          self.restInProgress = true;
          $monitoringService.getVendors()
            .then(function (res) {
              self.vendorList = res && res.listAppUser;
              self.vendorList.unshift({
                bankCode: "ILEAF_ARF",
                name: "TUTTI",
                identifier: null
              })
              self.restInProgress = false;
              self.fetchAndRedrawCharts();
            })
          self.selectedVendor = {
            bankCode: "ILEAF_ARF",
            name: "TUTTI",
            identifier: null
          }
        } else {
          //do not fetch vendors, just chart data
          self.fetchAndRedrawCharts();
        }

      }



      self.selectedPeriodicity = 'LAST_YEAR';
      self.selectPeriodicity = function (periodicity) {
        self.selectedPeriodicity = periodicity;
        self.fetchAndRedrawCharts(periodicity);
      }



      //fetches data and draws charts
      self.fetchAndRedrawCharts = function () {
        var periodicity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'LAST_YEAR';
        //fetch 
        $monitoringService.getChartData(keys, self.selectedVendor.identifier, periodicity)
          .then(function (res) {

            //list -> map
            var mappedList = {};
            res && res.listAppKpi
              .forEach(function (kpi) {
                mappedList[kpi['kpiName']] = kpi['kpiValue'];
              })


            self.configObj.left.sidebarIcons.map(function (el) {
              return el.number = mappedList[el.numberKey] || 0;
            });

            self.configObj.right.sidebarIcons.map(function (el) {
              return el.number = mappedList[el.numberKey] || 0;
            });

            //draw charts
            renderPieChart(mappedList['app.kpi.simulationsAndContractsChart']);
            renderBarChart(mappedList['app.kpi.proposalsChart']);
            renderDoughnutChart(mappedList['app.kpi.plafondChart']);

          })

      }

      //init component
      self.initialize();

      function renderPieChart(kpiObj) {
        if (pieChart) {
          pieChart.destroy();
        }

        var ctx = document.getElementById("pie").getContext('2d');
        pieChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: kpiObj && kpiObj.labels,
            datasets: [{
              backgroundColor: [
                "#1f5673",
                "#d6e5e3",
                "#5b2333"
              ],
              borderWidth: 3,
              borderColor: '#d8d8d8',
              data: kpiObj && kpiObj.dataset
            }]
          },
          options: {
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  console.log('tooltipItem', tooltipItem);
                  console.log('data', data);
                  //return chartData.labels[tooltipItem.index] + ': ' + chartData.datasets[0].data[tooltipItem.index] + '%';

                  //get the concerned dataset
                  var dataset = data.datasets[tooltipItem.datasetIndex];
                  //calculate the total of this data set
                  var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                    return previousValue + currentValue;
                  });
                  //get the current items value
                  var currentLabel = data.labels[tooltipItem.index];
                  var currentValue = dataset.data[tooltipItem.index];
                  //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
                  var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                  return currentLabel + ': ' + precentage + "%";
                }
              }
            },
            legend: {
              display: false,
              position: 'right',
              labels: {
                fontSize: 10
              }
            },
          }
        });
      }


      var barChartFontSize = window.innerWidth > 1200 ? 12 : 8;
      console.log(barChartFontSize);

      function renderBarChart(kpiObj) {
        if (barChart) {
          barChart.destroy();
        }
        var ctx = document.getElementById("bar").getContext('2d');
        barChart = new Chart(ctx, {
          type: 'horizontalBar',
          data: {
            labels: kpiObj && kpiObj.labels,
            datasets: [{
              label: self.selectedPeriodicity == 'LAST_YEAR' ? "Ultimi 12 mesi" : "Ultimi 30 giorni",
              backgroundColor: ["rgba(214, 229, 227, 1)", "rgba(31, 86, 115, 1)", "rgba(220, 204, 163, 1)", "rgba(188, 171, 174, 1)", "rgba(91, 35, 51, 1)"],
              borderColor: "#d8d8d8",
              borderWidth: 3,
              hoverBorderColor: "#d8d8d8",
              data: kpiObj && kpiObj.dataset,
            }]
          },
          options: {
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return data.datasets[0].data[tooltipItem.index];
                }
              }
            },
            plugins: {
              datalabels: {
                display: true
              }
            },
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
              }
            },
            scales: {
              xAxes: [{
                gridLines: {
                  display: false
                },
                barPercentage: 0.8,
                ticks: {
                  fontSize: barChartFontSize,
                  beginAtZero: true,
                  callback: function (value) {
                    if (Number.isInteger(value)) {
                      return value;
                    }
                  },
                  stepSize: 5
                }
              }],
              yAxes: [{
                gridLines: {
                  display: false
                },
                ticks: {
                  fontSize: barChartFontSize
                }
              }]
            },
            legend: {
              display: false
            }
          }
        });
      }

      function renderDoughnutChart(kpiObj) {
        if (doughnutChart) {
          doughnutChart.destroy();
        }
        var ctx = document.getElementById("doughnut").getContext('2d');
        doughnutChart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: kpiObj && kpiObj.labels,
            datasets: [{
              backgroundColor: [
                "#1f5673",
                "#d6e5e3",
                "#5b2333"
              ],
              borderWidth: 3,
              borderColor: '#d8d8d8',
              data: kpiObj && kpiObj.dataset
            }]
          },
          options: {
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  //get the concerned dataset
                  var dataset = data.datasets[tooltipItem.datasetIndex];
                  //calculate the total of this data set
                  var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                    return previousValue + currentValue;
                  });

                  var currentLabel = data.labels[tooltipItem.index];
                  //get the current items value
                  var currentValue = dataset.data[tooltipItem.index];
                  //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
                  var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                  return currentLabel + ': ' + precentage + "%";
                }
              }
            },
            legend: {
              display: false,
              labels: {
                fontSize: 10
              }
            }
          }
        });
      }



    }
  });